@if (isAuthenticated()) {
    @if (hasHomeDashboardAccess()) {
        <app-dashboard-header subtitle="Welcome Back, Ei User" buttonText="Add New Client">
        </app-dashboard-header>

        <!-- RM Main Content -->
        @if (!hasReportees()) {
            <div class="dashboard__content">
                @if (
                    permissionService.getPermissionByName(PERMISSIONS.MY_MATRIX) ||
                    permissionService.getPermissionByName(PERMISSIONS.MY_MATRIX_VIEW)
                ) {
                    <div class="dashboard__row dashboard__row--two-column">
                        <app-core-metrics></app-core-metrics>
                        <app-monthly-leaderboard></app-monthly-leaderboard>
                    </div>
                }

                @if (permissionService.getPermissionByName(PERMISSIONS.MY_DEALS)) {
                    <div class="dashboard__row">
                        <app-alerts-strip></app-alerts-strip>
                    </div>
                }

                @if (permissionService.getPermissionByName(PERMISSIONS.MY_FUNNEL)) {
                    <!-- Sales Funnel Row -->
                    <div class="dashboard__row">
                        <app-sales-funnel-overview></app-sales-funnel-overview>
                    </div>
                }

                @if (permissionService.getPermissionByName(PERMISSIONS.MY_DEALS)) {
                    <!-- Deals Pipeline Row -->
                    <div class="dashboard__row">
                        <app-deals-pipeline></app-deals-pipeline>
                    </div>
                }
            </div>
        }
        <!-- Team View Main Content -->
        @if (hasReportees()) {
            <div class="zm-tabs__content">
                <div class="zm-tabs">
                    <div class="zm-tabs__header">
                        <div class="ei-tabs" role="tablist" aria-label="Dashboard tabs">
                            <button
                                type="button"
                                class="ei-tabs__tab"
                                role="tab"
                                [attr.aria-selected]="selectedTabIndex === 0"
                                [class.ei-tabs__tab--active]="selectedTabIndex === 0"
                                (click)="onTabChange(0)"
                            >
                                My Data
                            </button>
                            <button
                                type="button"
                                class="ei-tabs__tab"
                                role="tab"
                                [attr.aria-selected]="selectedTabIndex === 1"
                                [class.ei-tabs__tab--active]="selectedTabIndex === 1"
                                (click)="onTabChange(1)"
                            >
                                Team View
                            </button>
                        </div>
                    </div>

                    @if (selectedTabIndex === 0) {
                        <div class="dashboard__content">
                            @if (
                                permissionService.getPermissionByName(PERMISSIONS.MY_MATRIX) ||
                                permissionService.getPermissionByName(PERMISSIONS.MY_MATRIX_VIEW)
                            ) {
                                <div class="dashboard__row dashboard__row--two-column">
                                    <app-core-metrics></app-core-metrics>
                                    <app-monthly-leaderboard></app-monthly-leaderboard>
                                </div>
                            }

                            @if (permissionService.getPermissionByName(PERMISSIONS.MY_DEALS)) {
                                <div class="dashboard__row">
                                    <app-alerts-strip></app-alerts-strip>
                                </div>
                            }

                            @if (permissionService.getPermissionByName(PERMISSIONS.MY_FUNNEL)) {
                                <!-- Sales Funnel Row -->
                                <div class="dashboard__row">
                                    <app-sales-funnel-overview></app-sales-funnel-overview>
                                </div>
                            }

                            @if (permissionService.getPermissionByName(PERMISSIONS.MY_DEALS)) {
                                <!-- Deals Pipeline Row -->
                                <div class="dashboard__row">
                                    <app-deals-pipeline></app-deals-pipeline>
                                </div>
                            }
                        </div>
                    } @else {
                        <div class="dashboard__content dashboard__content--team-view">
                            @if (zoneInfoLoading()) {
                                <div class="dashboard__row">
                                    <div
                                        class="zone-info zone-info--skeleton"
                                        aria-label="Loading zone info"
                                    >
                                        <div
                                            class="zone-info__title zone-info__title--skeleton"
                                        ></div>
                                        <div
                                            class="zone-info__subtitle zone-info__subtitle--skeleton"
                                        ></div>
                                    </div>
                                </div>
                            } @else if (zoneInfo()) {
                                <div class="dashboard__row">
                                    <div class="zone-info">
                                        <h2 class="zone-info__title">Complete Zone Data</h2>
                                        <p class="zone-info__subtitle">
                                            Zone – {{ zoneInfo()?.zoneName }} ·
                                            {{ zoneInfo()?.teamMembersCount }} team members ·
                                            {{ zoneInfo()?.citiesCount }} cities
                                        </p>
                                    </div>
                                </div>
                            }
                            <div class="dashboard__row dashboard__row--two-column">
                                <div class="dashboard__container-right">
                                    <app-core-metrics
                                        [title]="valueConstants.ZONE_METRICS_TITLE"
                                        [isTeamView]="true"
                                    ></app-core-metrics>
                                </div>
                                <div>
                                    <app-lead-sources></app-lead-sources>
                                </div>
                            </div>
                            <div class="dashboard__row dashboard__row--alerts-strip">
                                <app-alerts-strip></app-alerts-strip>
                            </div>
                            <div
                                class="dashboard__row dashboard__row--two-column dashboard__row--split-70-30"
                            >
                                <div>
                                    <div class="new-leads-filters" #newLeadsFiltersHost>
                                        <!-- City Filter -->
                                        <div class="filter-dropdown">
                                            <button
                                                class="filter-dropdown__button"
                                                (click)="
                                                    toggleNewLeadsDropdown('city');
                                                    $event.stopPropagation()
                                                "
                                                [class.filter-dropdown__button--active]="
                                                    selectedCity !== valueConstants.ALL_CITIES
                                                "
                                                type="button"
                                            >
                                                {{ selectedCity }}
                                                <img
                                                    src="assets/icons/dropdown-arrow.svg"
                                                    alt="Dropdown arrow"
                                                    class="filter-dropdown__icon"
                                                />
                                            </button>

                                            @if (isCityDropdownOpen()) {
                                                <div
                                                    class="filter-dropdown__menu"
                                                    (click)="$event.stopPropagation()"
                                                >
                                                    @for (
                                                        option of cityFilterOptions;
                                                        track option.value
                                                    ) {
                                                        <div
                                                            class="filter-dropdown__option"
                                                            [class.filter-dropdown__option--selected]="
                                                                selectedCity === option.value
                                                            "
                                                            (click)="selectCityFilter(option.value)"
                                                        >
                                                            {{ option.label }}
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>

                                        <!-- Sales Rep Filter -->
                                        <div class="filter-dropdown">
                                            <button
                                                class="filter-dropdown__button"
                                                (click)="
                                                    toggleNewLeadsDropdown('rm');
                                                    $event.stopPropagation()
                                                "
                                                [class.filter-dropdown__button--active]="
                                                    selectedRM !== AppConstants.ALL_REPS
                                                "
                                                type="button"
                                            >
                                                {{ selectedRM }}
                                                <img
                                                    src="assets/icons/dropdown-arrow.svg"
                                                    alt="Dropdown arrow"
                                                    class="filter-dropdown__icon"
                                                />
                                            </button>

                                            @if (isRMDropdownOpen()) {
                                                <div
                                                    class="filter-dropdown__menu"
                                                    (click)="$event.stopPropagation()"
                                                >
                                                    @for (
                                                        option of rmFilterOptions;
                                                        track option.value
                                                    ) {
                                                        <div
                                                            class="filter-dropdown__option"
                                                            [class.filter-dropdown__option--selected]="
                                                                selectedRM === option.value
                                                            "
                                                            (click)="selectRMFilter(option.value)"
                                                        >
                                                            {{ option.label }}
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>

                                        <!-- Product Filter -->
                                        <div class="filter-dropdown">
                                            <button
                                                class="filter-dropdown__button"
                                                (click)="
                                                    toggleNewLeadsDropdown('product');
                                                    $event.stopPropagation()
                                                "
                                                [class.filter-dropdown__button--active]="
                                                    selectedProduct !== AppConstants.ALL_PRODUCTS
                                                "
                                                type="button"
                                            >
                                                {{ selectedProduct }}
                                                <img
                                                    src="assets/icons/dropdown-arrow.svg"
                                                    alt="Dropdown arrow"
                                                    class="filter-dropdown__icon"
                                                />
                                            </button>

                                            @if (isProductDropdownOpen()) {
                                                <div
                                                    class="filter-dropdown__menu"
                                                    (click)="$event.stopPropagation()"
                                                >
                                                    @for (
                                                        option of productFilterOptions;
                                                        track option.value
                                                    ) {
                                                        <div
                                                            class="filter-dropdown__option"
                                                            [class.filter-dropdown__option--selected]="
                                                                selectedProduct === option.value
                                                            "
                                                            (click)="
                                                                selectProductFilter(option.value)
                                                            "
                                                        >
                                                            {{ option.label }}
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div class="dashboard__row">
                                        <app-new-leads-created
                                            [selectedCity]="selectedCity"
                                            [selectedRM]="selectedRM"
                                            [selectedProduct]="selectedProduct"
                                            [rmNames]="rmNames"
                                            (cityChange)="onCityFilterChange($event)"
                                            (rmChange)="onRMFilterChange($event)"
                                            (productChange)="onProductFilterChange($event)"
                                            (filtersLoaded)="onNewLeadsFiltersLoaded($event)"
                                        ></app-new-leads-created>
                                    </div>
                                    <!-- Lead Conversion Metrics Row -->
                                    <div class="dashboard__row">
                                        <app-lead-conversion-metrics></app-lead-conversion-metrics>
                                    </div>
                                </div>
                                <div class="dashboard__container-left">
                                    <!-- Team Performance card -->
                                    <app-rm-performance-dashboard
                                        [zmUserId]="zmUserId || ''"
                                        height="810px"
                                        (rmNamesChange)="onRMNamesChange($event)"
                                    ></app-rm-performance-dashboard>
                                </div>
                            </div>
                            <!-- Sales Funnel Row -->
                            <div class="dashboard__row">
                                <app-sales-funnel-overview></app-sales-funnel-overview>
                            </div>
                            <div class="dashboard__row">
                                <app-deals-pipeline [isTeamView]="true"></app-deals-pipeline>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    } @else {
        <div class="dashboard__coming-soon">
            <div class="dashboard__coming-soon-inner">
                <div class="dashboard__coming-soon-icon-wrap" aria-hidden="true">
                    <app-svg-icon name="schedule" size="lg" class="dashboard__coming-soon-icon" />
                </div>

                <div class="dashboard__coming-soon-eyebrow">
                    <span class="dashboard__coming-soon-eyebrow-pill">{{
                        homeDashboardComingSoonText.eyebrowPill
                    }}</span>
                    <span class="dashboard__coming-soon-eyebrow-text">{{
                        homeDashboardComingSoonText.eyebrowLabel
                    }}</span>
                </div>

                <h1 class="dashboard__coming-soon-title">
                    {{ homeDashboardComingSoonText.title }}
                </h1>

                <p class="dashboard__coming-soon-message">
                    {{ homeDashboardComingSoonText.message }}
                </p>

                <p class="dashboard__coming-soon-beta-label">
                    {{ homeDashboardComingSoonText.betaLabel }}
                </p>
            </div>
        </div>
    }
}
